<!-- @format -->

<button
	sharedComponentsLongpress
	[attr.aria-label]="ariaLabel()"
	class="carousel-button hmf-body-bold-m hmf-display-flex hmf-align-items-center hmf-justify-content-center"
	[ngClass]="{
		'btn-visibility': (previous() && showLeftArrow()) || (!previous() && showRightArrow())
	}"
	(mouseLongPress)="onClick()"
	(click)="onClick()">
	{{ label() }}
	<homefield-icon
		aria-hidden="true"
		class="carousel-button-svg"
		width="24px"
		height="24px"
		name="{{ 'chevron-' + (previous() ? 'left' : 'right') }}">
	</homefield-icon>
</button>
